import { getFormattedDateString } from "../utils/getFormattedDateString";

export const searchResultOtherCard = (item) => {
    const searchLocale = window.jslocale?.search || {};
    const prefetchedLocale = window.jslocale?.prefetched || {};

    // desctructuring and default values for searchLocale
    const { details: courseDetails, published: otherDatePrefix } = searchLocale;

    const { sem_title, sem_excerpt, sem_creation_date, url_s } = item;

    const dateCreated = getFormattedDateString(sem_creation_date);

    const detailsButton = url_s
        ? `<div class="so-res-link"><a href="${url_s}" class="so-res-details-button" aria-label="${courseDetails}">${courseDetails}</a></div>`
        : '<div class="so-res-link"></div>';

    return `
    <div class="so-res-other">
        <div class="so-res-other-contents">
            <div class="so-res-other-content">
                <div class="so-res-title">${sem_title}</div>
                <div class="so-res-desc">${sem_excerpt}</div>
            </div>
            <div class="so-res-other-details">
                <div class="so-res-info">
                    <svg aria-hidden="true">
                        <use xlink:href="/images/frontend/main-icons.svg#time-icon"></use>
                    </svg>
                    <span>${otherDatePrefix}: ${dateCreated}</span>
                </div>
                ${detailsButton}
            </div>
        </div>
    </div>`;
};
